import { Spinner, SpinnerSize } from "@fluentui/react";
import React from "react";

import { Stack } from "../layouts/stack/Stack";

export const LoadingScreen: React.FunctionComponent = () => {
    return (
        <Stack>
            <Spinner size={SpinnerSize.large} />
        </Stack>
    );
};
